import LocationNavigation from './LocationNavigation.vue';

export default {
    props: {
        country: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            open: false
        }
    },

    methods: {
        toggle() {
            this.open = !this.open;

            EventBus.$emit('ToggleModal');
        },
    },

    computed: {
        flagClass() {
            return `flag--${this.location.country}`;
        }
    },

    components: {
        LocationNavigation
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/LocationSelector.js